<template>
  <div>
    <v-dialog persistent v-model="dialog1" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn
          class='mt-5'
          :color="color"
          :dark="dark"
          :large="large"
          :disabled="disable"
          v-on="on">{{buttonText}}</v-btn>
      </template>
      <v-card>
        <v-card-title>Create Account</v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid">
            <v-text-field
              :rules='emailRules'
              v-model='setEmail'
              label="Please Enter Your Email Address"
              required
              outline></v-text-field>
            <v-text-field
              :append-icon="show1 ? 'visibility' : 'visibility_off'"
              @click:append="show1 = !show1"
              :type="show1 ? 'text' : 'password'"
              :rules='passwordRules'
              v-model='setPassword'
              label="Please enter a password."
              required
              outline></v-text-field>
            <v-text-field
              :append-icon="show1 ? 'visibility' : 'visibility_off'"
              @click:append="show1 = !show1"
              :type="show1 ? 'text' : 'password'"
              :rules='verifyRules'
              label="Please verify your password."
              required
              outline></v-text-field>
            <v-btn :disabled="!valid" color="primary" text @click="createAccount()">Sign up</v-btn>
            <v-btn :disabled="!valid" color="black" text @click="dialog1 = false">Close</v-btn>
          </v-form>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="createdDialog" max-width="500px">
      <v-card>
        <v-card-title>

        </v-card-title>
        <v-card-text>
          Congrats on setting up your own My Genetic Trust account, Login to your account to start.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="redirect()">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapFields } from 'vuex-map-fields';
  import router from '@/router';
export default {
    props : {
        disable : Boolean,
        buttonText : String,
        color : String,
        dark : Boolean,
        large : Boolean,
        plan : Number
    },
    data() {
      return {
        fieldRules : [
          v => !!v || 'this field is required',
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [
          v => /[a-z]+/.test(v) || 'One lowercase letter required.',
          v => /[A-Z]+/.test(v) || 'One uppercase letter required.',
          v => /.{8,}/.test(v) || '8 characters minimum.',
          v => /[0-9]+/.test(v) || 'One number required.'
        ],
        verifyRules: [
          v => v === this.setPassword || 'Passwords must match'
        ],
        valid : true,
        dialog1 : false,
        createdDialog: false,
        show1 : false,
        setEmail: "",
        setPassword: "",
      }
    },
    computed : {
      ...mapFields([
        'isAuthorized',
        'user',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
      ...mapFields("patientQuestion", [
        "selectedPlan"
      ]),
    },
    mounted() {
    },
    methods : {
      redirect(){
        router.replace('/login')
      },
      createAccount() {
        this.selectedPlan = this.plan
        const createURL = 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=' + process.env.VUE_APP_ROOT_API_KEY
        const createOptions = {
          "email": this.setEmail,
          "password": this.setPassword,
          "returnSecureToken": true
        }
        this.$axios
          .post(createURL, createOptions)
          .then( () => {
             this.createdDialog = true
          })
          .catch( () => {
            this.snackBarType = "warning"
            this.snackBarshow =true;
            this.snackBarmessage = "Error";
          })
      }
    }
  }
</script>
<style>

</style>
